import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollagePagePropertiesComponent } from './collage-page-properties.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LucideIconsModule } from '../../../../shared/lucide-icons.module';



@NgModule({
    declarations: [
        CollagePagePropertiesComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule, MatIconModule,
        LucideIconsModule, MatSnackBarModule,
        MatCheckboxModule
    ]
})
export class CollagePagePropertiesModule { }
